<template>
  <div>
    <EDialog
      dialog-title="查看导入结果"
      :center-dialog-visible="importResultVisible"
      popup-width="800px"
      :close-btn="true"
      @resetPopupData="handleClose"
    >
      <TableList row-key="id" :loading="false" :index-show="true" :table-data="tableData" :table-label="tableLabel">
        <template #fileUrl="{ scope: { row } }">
          <el-button type="text" @click="downloadResult(row.fileUrl, row.fileName)">下载导入结果</el-button>
        </template>
      </TableList>
      <div class="margin-t10 danger">导入结果只保留最近10次的记录</div>
    </EDialog>
  </div>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import TableList from '@/modules/projectA/components/common/e-table-list';
import api from '@/modules/projectA/api/agreement';

export default {
  name: 'ViewImportResultDialog',
  components: {
    EDialog,
    TableList,
  },
  props: {
    importResultVisible: Boolean,
  },
  data() {
    return {
      indexShow: true,
      tableData: [],
      tableLabel: [
        { label: '导入时间', param: 'createTime', align: 'center' },
        { label: '操作人', param: 'memberName', align: 'center' },
        { label: '导入结果', param: '', align: 'center', slot: 'fileUrl' },
      ],
    };
  },
  watch: {
    importResultVisible(newVal) {
      if (newVal) {
        this.getImportRecord();
      }
    },
  },
  mounted() {
    this.getImportRecord();
  },
  methods: {
    // 下载
    downloadResult(fileUrl, fileName) {
      /* console.log(fileUrl, fileName, 'fileName');
      const a = document.createElement('a'); // 创建一个<a></a>标签
      a.href = fileUrl; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.download = fileName; // 设置下载文件文件名，这里加上.xls指定文件类型，pdf文件就指定.fpd即可
      a.style.display = 'none'; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签 */
      const downloadRes = async () => {
        const response = await fetch(fileUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    handleClose() {
      this.$emit('closeDialog', 'importResultVisible');
      this.$emit('update:importResultVisible', false);
    },
    async getImportRecord() {
      const res = await api.importResultAgreement();
      if (res.code === '200') {
        this.tableData = res.data;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.margin-t10 {
  margin-top: 10px;
}
</style>
